import styled from "styled-components";

export const Box = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: Arial, sans-serif;
  }
  body {
    background-color: #f0f0f0;
    padding: 2rem;
  }

  .container_sero {
    max-width: 1200px;
    margin: 0 auto;
  }

  .container_sero h1 {
    color: #1a1a1a;
    margin-bottom: 2rem;
    font-size: 2rem;
  }

  .container_sero .grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  align-items: stretch;
}


  @media (min-width: 1024px) {
    .container_sero .grid {
      grid-template-columns: 1fr 1fr;
    }
  }
  @media (max-width: 1024px) {
    .container_sero .grid {
      display: block;
    }
    .serp-preview1 {
      margin-top: 1rem;
    }
  }
  @media (max-width: 768px) {
    .search-header {
      display: block !important;
      padding: 20px 10px 5px 10px;
    }
    .search-header .formgoogle {
      margin-top: 1rem;
    }
    .search-logo {
      padding: 4px 0 0 4px !important;
    }
  }

  .container_sero .card {
    width: 100%;
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    height: 100%;
  }

  .container_sero .form-group {
    margin-bottom: 1rem;
  }

  .container_sero .form-group label {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.5rem;
  }

  .container_sero .form-group input,
  .container_sero .form-group textarea {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 0.875rem;
  }

  .container_sero .form-group input:focus,
  .container_sero .form-group textarea:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }

  .container_sero .char-count {
    font-size: 0.75rem;
    color: #6b7280;
    margin-left: 0.5rem;
  }

  .container_sero .error {
    border-color: #ef4444 !important;
  }

  .container_sero .button-group {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .container_sero .button {
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    font-size: 0.875rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s;
  }

  .container_sero .button-primary {
    background-color: #3b82f6;
    color: white;
  }

  .container_sero .button-primary:hover {
    background-color: #2563eb;
  }

  .container_sero .button-secondary {
    background-color: #e5e7eb;
    color: #374151;
  }

  .container_sero .button-secondary:hover {
    background-color: #d1d5db;
  }

  .container_sero .button.active {
    background-color: #2563eb;
    color: white;
  }

  /* SERP Preview Styles */
  .container_sero .serp-preview {
    background-color: white;
    padding: 1.5rem;
    // font-family: Arial, sans-serif;
    transition: all 0.3s;
    width: 100%;
  }

  .container_sero .mobile {
    max-width: 360px;
    margin: 0 auto;
  }

  .container_sero .desktop {
    max-width: 600px;
    margin: 0 auto;
  }

  .container_sero .serp-title {
    color: #1a0dab;
    font-size: 1.125rem;
    margin-bottom: 0.25rem;
    cursor: pointer;
  }

  .container_sero .serp-title:hover {
    text-decoration: underline;
  }

  .container_sero .serp-url {
    color: #006621;
    font-size: 0.875rem;
    margin-bottom: 0.25rem;
  }

  .container_sero .serp-description {
    color: #4d5156;
    font-size: 0.875rem;
    line-height: 1.4;
  }

  .container_sero .serp-description strong {
    font-weight: bold;
  }

  .container_sero .tips {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #e5e7eb;
  }

  .container_sero .tips h3 {
    font-size: 1rem;
    color: #1f2937;
    margin-bottom: 0.5rem;
  }

  .container_sero .tips ul {
    list-style-type: none;
    font-size: 0.875rem;
    color: #6b7280;
  }

  .container_sero .tips li {
    margin-bottom: 0.25rem;
    padding-left: 1rem;
    position: relative;
  }

  .container_sero .tips li::before {
    content: "•";
    position: absolute;
    left: 0;
  }

  .container_sero .google-bg {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
    margin-top: 1rem;
    padding: 1rem;
  }
  .serp-preview1 {
    border-top: 20px solid #d5d6e0;
    padding-top: 20px;
    // width: 55% !important;
    border-radius: 14px;
    background: #f7f7f700;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  .search-header {
    width: 100%;
    padding-top: 20px;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #ebebeb;
    display: flex;
  }
  .search-logo {
    padding: 4px 28px 0 30px;
  }
  .formgoogle {
    width: 100%;
    margin-right: 10px;
  }
  .uk-position-relative {
    position: relative !important;
  }
  .mg-label {
    line-height: 16px;
    min-height: 0;
    padding: 0 0.3529411765rem;
    background: #ffbe02;
    border-radius: 4px;
    color: #fff !important;
    display: inline-block;
    letter-spacing: initial;
    text-decoration: none !important;
    user-select: none;
    font-size: 12px !important;
    position: absolute !important;
    margin-top: 15px;
    margin-left: 15px;
  }
  .search-input {
    outline: none;
    margin: 0;
    background: #fff;
    display: flex;
    border-style: solid !important;
    border-width: 1px 1px 1px 1px !important;
    border-color: #dfe1e5 !important;
    box-shadow: none;
    width: 100% !important;
    border-radius: 24px !important;
    z-index: 3;
    height: 40px;
    color: #222;
    padding: 8px 25px !important;
    font-size: 15px;
    padding-left: 58px !important;
    line-height: 20px;
  }
  .search-menu.uk-flex {
    display: flex;
    margin-bottom: 20px !important;
  }
  .search-cat {
    padding: 16px 12px 12px 10px;
    color: #5f6368;
    font-size: 13px;
    line-height: 16px;
    margin: 11px 1px 0;
  }
  .search-cat.is-active {
    border-style: solid;
    border-width: 0 0 3px 0;
    border-color: #1a73e8;
    color: #1a73e8;
    font-weight: bold;
  }
  .serp-url {
    color: #006621;
    margin-bottom: 5px;
  }
  .serp-result {
    margin-top: 1rem;
  }
  .serp-title {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: block;
  max-width: 600px;
  width: 550px;
}

  .serp-description {
    color: #545454;
  }
  .snippet-url {
    background: #5f6368;
    width: 30%;
    opacity: 0.3;
    cursor: default;
    min-height: 16px;
    margin-bottom: 8px;
    display: block;
  }
  .snippet-title {
    min-height: 16px;
    margin-bottom: 8px;
    display: block;
    background: #1a0dab;
    width: 60%;
    opacity: 0.3;
    cursor: default;
  }
  .snippet-descr {
    min-height: 40px;
    margin-bottom: 8px;
    display: block;
    background: #4d5156;
    width: 90%;
    opacity: 0.3;
    cursor: default;
  }
  .meta-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #cccccc;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s ease;
}
  .meta-textarea.error {
  border-color: #d9534f !important; /* smoother red tone */
  background: #fff6f6; /* very light red tint */
}
  .warning-box {
  background: #ffeaea;
  color: #a94442;
  padding: 10px 12px;
  border-left: 4px solid #d9534f;
  margin-top: 8px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.4;
}
  .meta-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #cccccc;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s ease;
}

.meta-input.error {
  border-color: #d9534f !important;
  background: #fff6f6;
}
.pixel-bar-wrapper {
  width: 100%;
  height: 4px;
  background: #e3e3e3;
  border-radius: 4px;
  margin-bottom: 6px;
  overflow: hidden;
}

.pixel-bar {
  height: 100%;
  transition: all 0.25s ease;
  border-radius: 4px;
}

.meta-input,
.meta-textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #cfcfcf;
  border-radius: 6px;
  font-size: 14px;
  background: #fff;
  transition: 0.2s ease;
}

.meta-input.error,
.meta-textarea.error {
  border-color: red !important;
  background: #ffecec;
}

.warning-box {
  background: #ffecec;
  color: #a94442;
  padding: 10px 12px;
  border-left: 4px solid red;
  margin-top: 8px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.4;
}

`;
